import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AproposComponent from "../components/AproposComponent";
import {
  Box,
  Container,
  RowTow,
  Row,
  ColumnTow,
  Column,
} from "../components/FooterStyles";
import { API_URL } from "../constant";

import "../styles/home.scss";
import Covid from "./Covid";

const Hero = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const history = useHistory();
  const [searchInProgress, setSearchLoading] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const makeSearch = (e) => {
    e.preventDefault();
    if (searchInProgress) {
      return;
    }
    setSearchLoading(true);
    // console.log("nom", e.target.nom.value);
    // console.log("ou", e.target.ou.value);
    // console.log("quand", e.target.quand.value);
    fetch(API_URL + "search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        title: e.target.nom.value,
        where: e.target.ou.value,
        date: new Date(e.target.quand.value),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setSearchLoading(false);
        if (data.success) {
          if (data.data.length == 0) {
            alert("Aucun résultat.");
          } else {
            history.push({
              pathname: "/categories/search",
              state: {
                data: data.data,
                title: e.target.nom.value,
                where: e.target.ou.value,
                date: e.target.quand.value,
                time: (e.target.time && e.target.time.value) || null,
              },
            });
          }
        } else {
          alert("Une erreur s'est produite lors de la recherche");
        }
      })
      .catch((err) => {
        setSearchLoading(false);
        console.log(err);
      });
  };
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.indexOf("android") > -1;
  return (
    <>
      {isAndroid ? (
        <div
          style={{
            background:
              size.width > 1200 &&
              " linear-gradient(0.25turn, #e2e4e1, #e2e4e1, #e5e7e4)",
          }}
        >
          <div
            className="composant-29-1"
            style={{
              background: isAndroid
                ? `url('https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62341339dacf5d485e5362f3/img/hero-banner-on-fleek@1x.png') no-repeat center top fixed`
                : `url('https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62341339dacf5d485e5362f3/img/hero-banner-on-fleek@1x.png') no-repeat center `,
              margin: "auto",
            }}
          >
            <div
              className="onglet-de-recherche"
              style={{
                height: size.width > 1380 ? 130 : size.width > 1100 ? 180 : 260,
              }}
            >
              <div className="barre-de-recherche">
                <form onSubmit={makeSearch}>
                  <Row className="customSearch">
                    <ColumnTow>
                      <div className="nom-du-salon-ou-de-la-prestation">
                        <input
                          className="nom-du-salon-prestations-couperaleway-normal-silver-14px"
                          name="nom"
                          placeholder="Nom du salon, prestations (coupe…)"
                          type="text"
                          autocomplete="off"
                          style={{
                            paddingLeft: 0,
                            fontFamily: "Raleway",
                            maxWidth:
                              size.width > 600
                                ? 220
                                : size.width > 360
                                ? "80%"
                                : size.width > 320
                                ? 195
                                : 160,
                            // width: size.width > 600 && 200,
                          }}
                        />
                        <div className="search">
                          <img
                            className="icon-awesome-search-alt"
                            src={process.env.PUBLIC_URL + "/trac-208-2.png"}
                            alt=""
                          />
                        </div>
                        <img
                          className="ligne-1"
                          src={process.env.PUBLIC_URL + "/ligne-1-14.png"}
                          alt=""
                        />
                      </div>
                    </ColumnTow>
                    <div className="lieu">
                      <img
                        className="icon-material-location-on"
                        src={
                          process.env.PUBLIC_URL +
                          "/icon-material-location-on-1.png"
                        }
                        alt=""
                      />
                      <input
                        className="oraleway-normal-silver-14px"
                        name="ou"
                        placeholder="Où ? (Adresse, ville, ...)"
                        style={{ fontFamily: "Raleway!important" }}
                      />
                      <img
                        className="ligne-2"
                        src={process.env.PUBLIC_URL + "/ligne-2-2.png"}
                        alt=""
                      />
                    </div>
                    <ColumnTow>
                      <div className="date">
                        {navigator.userAgent.includes("Safari") &&
                        !navigator.userAgent.includes("Android") &&
                        !navigator.userAgent.includes("Chrome") ? (
                          <img
                            className="icon-awesome-calendar-alt"
                            src={
                              process.env.PUBLIC_URL +
                              "/icon-awesome-calendar-alt-1.png"
                            }
                            alt=""
                          />
                        ) : (
                          <img
                            className="icon-awesome-calendar-alt"
                            style={{ position: "absolute" }}
                            src={
                              process.env.PUBLIC_URL +
                              "/icon-awesome-calendar-alt-1.png"
                            }
                            alt=""
                          />
                        )}

                        {navigator.userAgent.includes("Safari") &&
                        !navigator.userAgent.includes("Android") &&
                        !navigator.userAgent.includes("Chrome") ? (
                          <input
                            type={"datetime-local"}
                            className="quandraleway-normal-silver-14px"
                            name="quand"
                            style={{
                              fontFamily: "Raleway!important",
                              marginLeft:
                                (size.width < 600 || size.width == 1080) && 20,
                              position:
                                (size.width < 600 || size.width == 1080) &&
                                "relative",
                              top:
                                (size.width < 600 || size.width == 1080) && -8,
                            }}
                          />
                        ) : (
                          <>
                            <div
                              style={{
                                display: "flex",
                                position: "relative",
                                top: 0,
                                marginLeft: 10,
                                background: "transparent",
                                height: 20,
                                left: 20,
                              }}
                            >
                              <input
                                type={"date"}
                                className="quandraleway-normal-silver-14px"
                                name="quand"
                                placeholder="Quand ? "
                                style={{
                                  paddingLeft: 0,
                                  background: "transparent",
                                  fontFamily: "Raleway!important",
                                  color: "#aea9a9",
                                }}
                              />
                              <input
                                name="time"
                                className="quandraleway-normal-silver-14px"
                                type="time"
                                placeholder="l'heure ? "
                                style={{
                                  paddingLeft: 0,
                                  background: "transparent",
                                  fontFamily: "Raleway!important",
                                  color: "#aea9a9",
                                }}
                              />
                            </div>
                          </>
                        )}
                        <img
                          className="ligne-2-1"
                          src={process.env.PUBLIC_URL + "/ligne-2-1.png"}
                          alt=""
                        />
                      </div>
                    </ColumnTow>
                    <ColumnTow>
                      {searchInProgress ? (
                        <div style={{ maxWidth: size.width === 375 && 278 }}>
                          <div
                            style={{
                              margin: "auto",
                              width: 55,
                              position: "relative",
                              right: 20,
                            }}
                          >
                            <div class="loader" />
                          </div>
                        </div>
                      ) : (
                        <>
                          {size.width >= 1080 ? (
                            <>
                              <button
                                type="submit"
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                              >
                                <div
                                  className="bouton-recherche"
                                  style={{
                                    marginLeft: size.width == 1080 && -20,
                                  }}
                                >
                                  <div
                                    className="search-1"
                                    style={{
                                      backgroundImage: `url('trac-208-1.png`,
                                    }}
                                  ></div>
                                </div>
                              </button>
                            </>
                          ) : (
                            <div
                            // style={{ width: size.width <= 428 && "calc(100% - 97px)" }}
                            >
                              <button
                                type="submit"
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                              >
                                <div
                                  class="bouton-plein"
                                  style={{
                                    height:
                                      size.width <= 1024 && "32px!important",
                                  }}
                                >
                                  <div class="rechercher">Rechercher</div>
                                  <div class="search-2"></div>
                                </div>
                              </button>

                              {/* <p>-- {size.width} -- pas ici</p>
                              <p>{navigator.userAgent}</p> */}
                            </div>
                          )}
                        </>
                      )}
                    </ColumnTow>
                  </Row>
                </form>
              </div>
            </div>
            <h1
              className="rservez-vos-rendez raleway-extra-bold-eerie-black-50px"
              style={{
                width:
                  size.width > 1288
                    ? "80%"
                    : size.width > 800
                    ? size.width * 0.9
                    : "100%",
                color: size.width > 1200 ? "black" : "white",
                top:
                  size.width > 1380
                    ? 120
                    : size.width > 1200
                    ? 100
                    : size.width > 414
                    ? size.width >= 428
                      ? size.width == 810
                        ? 50
                        : size.width == 768
                        ? -30
                        : -200
                      : -70
                    : size.width > 320
                    ? -50
                    : -90,
                textShadow: size.width > 1200 ? "none" : "0px 3px 15px black",
                maxWidth:
                  size.width > 1200
                    ? 1920
                    : size.width > 800
                    ? size.width * 0.8
                    : "100%",
                fontSize: size.width <= 360 ? 32 : size.width < 415 && 35,
              }}
            >
              Réservez vos rendez-vous beauté en ligne
            </h1>
          </div>
        </div>
      ) : (
        <div
          className="composant-29-9"
          style={{
            background: `url('https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62341339dacf5d485e5362f3/img/hero-banner-on-fleek@1x.png') center `,
            margin: "auto",
          }}
        >
          <div
            className="onglet-de-recherche"
            style={{
              height: size.width > 1380 ? 130 : size.width > 1100 ? 180 : 260,
            }}
          >
            <div className="barre-de-recherche">
              <form onSubmit={makeSearch}>
                <Row className="customSearch">
                  <ColumnTow>
                    <div className="nom-du-salon-ou-de-la-prestation">
                      <input
                        className="nom-du-salon-prestations-couperaleway-normal-silver-14px"
                        name="nom"
                        placeholder="Nom du salon, prestations (coupe…)"
                        type="text"
                        autocomplete="off"
                        style={{
                          paddingLeft: 0,
                          fontFamily: "Raleway",
                          maxWidth:
                            size.width > 600
                              ? 220
                              : size.width > 360
                              ? "80%"
                              : size.width > 320
                              ? 195
                              : 160,
                          // width: size.width > 600 && 200,
                        }}
                      />
                      <div className="search">
                        <img
                          className="icon-awesome-search-alt"
                          src={process.env.PUBLIC_URL + "/trac-208-2.png"}
                          alt=""
                        />
                      </div>
                      <img
                        className="ligne-1"
                        src={process.env.PUBLIC_URL + "/ligne-1-14.png"}
                        alt=""
                      />
                    </div>
                  </ColumnTow>
                  <div className="lieu">
                    <img
                      className="icon-material-location-on"
                      src={
                        process.env.PUBLIC_URL +
                        "/icon-material-location-on-1.png"
                      }
                      alt=""
                    />
                    <input
                      className="oraleway-normal-silver-14px"
                      name="ou"
                      placeholder="Où ? (Adresse, ville, ...)"
                      style={{ fontFamily: "Raleway!important" }}
                    />
                    <img
                      className="ligne-2"
                      src={process.env.PUBLIC_URL + "/ligne-2-2.png"}
                      alt=""
                    />
                  </div>
                  <ColumnTow>
                    <div className="date">
                      {navigator.userAgent.includes("Safari") &&
                      !navigator.userAgent.includes("Android") &&
                      !navigator.userAgent.includes("Chrome") ? (
                        <img
                          className="icon-awesome-calendar-alt"
                          src={
                            process.env.PUBLIC_URL +
                            "/icon-awesome-calendar-alt-1.png"
                          }
                          alt=""
                        />
                      ) : (
                        <img
                          className="icon-awesome-calendar-alt"
                          style={{ position: "absolute" }}
                          src={
                            process.env.PUBLIC_URL +
                            "/icon-awesome-calendar-alt-1.png"
                          }
                          alt=""
                        />
                      )}

                      {navigator.userAgent.includes("Safari") &&
                      !navigator.userAgent.includes("Android") &&
                      !navigator.userAgent.includes("Chrome") ? (
                        <input
                          type={"datetime-local"}
                          className="quandraleway-normal-silver-14px"
                          name="quand"
                          style={{
                            fontFamily: "Raleway!important",
                            marginLeft:
                              (size.width < 600 || size.width <= 1080) && 20,
                            position:
                              (size.width < 600 || size.width == 1080) &&
                              "relative",
                            top: (size.width < 600 || size.width == 1080) && -8,
                          }}
                        />
                      ) : (
                        <>
                          <div
                            style={{
                              display: "flex",
                              position: "relative",
                              top: 0,
                              marginLeft: 10,
                              background: "transparent",
                              height: 20,
                              left: 20,
                            }}
                          >
                            <input
                              type={"date"}
                              className="quandraleway-normal-silver-14px"
                              name="quand"
                              placeholder="Quand ? "
                              style={{
                                paddingLeft: 0,
                                background: "transparent",
                                fontFamily: "Raleway!important",
                                color: "#aea9a9",
                              }}
                            />
                            <input
                              name="time"
                              className="quandraleway-normal-silver-14px"
                              type="time"
                              placeholder="l'heure ? "
                              style={{
                                paddingLeft: 0,
                                background: "transparent",
                                fontFamily: "Raleway!important",
                                color: "#aea9a9",
                              }}
                            />
                          </div>
                        </>
                      )}
                      <img
                        className="ligne-2-1"
                        style={{
                          bottom: size.width == 1080 && 9,
                        }}
                        src={process.env.PUBLIC_URL + "/ligne-2-1.png"}
                        alt=""
                      />
                    </div>
                  </ColumnTow>
                  <ColumnTow>
                    {searchInProgress ? (
                      <div style={{ maxWidth: size.width === 375 && 278 }}>
                        <div
                          style={{
                            margin: "auto",
                            width: 55,
                            position: "relative",
                            right: 20,
                          }}
                        >
                          <div class="loader" />
                        </div>
                      </div>
                    ) : (
                      <>
                        {size.width >= 1080 ? (
                          <>
                            <button
                              type="submit"
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                            >
                              <div
                                className="bouton-recherche"
                                style={{
                                  marginLeft: size.width == 1080 && -20,
                                }}
                              >
                                <div
                                  className="search-1"
                                  style={{
                                    backgroundImage: `url('trac-208-1.png`,
                                  }}
                                ></div>
                              </div>
                            </button>
                          </>
                        ) : (
                          <div
                          // style={{ width: size.width <= 428 && "calc(100% - 97px)" }}
                          >
                            <button
                              type="submit"
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                            >
                              <div
                                class="bouton-plein"
                                style={{
                                  height:
                                    size.width <= 1024 && "32px!important",
                                }}
                              >
                                <div class="rechercher">Rechercher</div>
                                <div class="search-2"></div>
                              </div>
                            </button>

                            {/* <p>-- {size.width} -- ici</p> */}
                          </div>
                        )}
                      </>
                    )}
                  </ColumnTow>
                </Row>
              </form>
            </div>
          </div>
          <h1
            className="rservez-vos-rendez raleway-extra-bold-eerie-black-50px"
            style={{
              width:
                size.width > 1288
                  ? "80%"
                  : size.width > 800
                  ? size.width * 0.9
                  : "100%",
              color: size.width > 1200 ? "black" : "white",
              top:
                size.width > 1380
                  ? 120
                  : size.width > 1200
                  ? 100
                  : size.width > 414
                  ? size.width >= 428
                    ? size.width == 810
                      ? 50
                      : size.width == 768
                      ? -30
                      : -200
                    : -70
                  : size.width > 320
                  ? -50
                  : -90,
              textShadow: size.width > 1200 ? "none" : "0px 3px 15px black",
              maxWidth:
                size.width > 1200
                  ? 1920
                  : size.width > 800
                  ? size.width * 0.8
                  : "100%",
              fontSize: size.width < 415 && 35,
            }}
          >
            Réservez vos rendez-vous beauté en ligne
          </h1>
        </div>
      )}
    </>
  );
};

const DiscoverPro = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* {size.width} */}
      {/* <div class="dcouvrez-nos-professionnelsM fg" style={{ margin: "auto" }}>
        capture ici stp {size.width} -- {size.height}
      </div> */}
      {size.width <= 428 ? (
        <div class="catgoriesM">
          <div
            class="dcouvrez-nos-professionnelsM fg"
            style={{ margin: "auto" }}
          >
            Découvrez nos professionnels
          </div>
          {size.width >= 390 ? (
            <>
              <a href="/categories/coiffure" style={{ textDecoration: "none" }}>
                <div
                  class="overlap-group-2M"
                  style={{
                    width: size.width > 390 ? 378 : size.width === 390 && 341,
                    // marginLeft: size.width === 393 && "20px!important",
                  }}
                >
                  <div class="coiffeurM raleway-bold-eerie-black-15pxM">
                    Coiffure
                  </div>
                  <img
                    style={{
                      top: size.width === 390 && 190,
                      left: size.width === 390 ? 10 : 8,
                    }}
                    alt=""
                    class="ligne-3M"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                  />
                  <img
                    alt=""
                    class="coiffure-mobile-on-fleekM"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/coiffure-mobile-on-fleek@1x.png"
                  />
                </div>
              </a>
              <div
                class="overlap-group-containerM"
                style={{
                  width: size.width === 428 && 381,
                }}
              >
                <a href="/categories/barber" style={{ textDecoration: "none" }}>
                  <div class="overlap-groupM">
                    <img
                      alt=""
                      class="x-on-fleekM"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/barber-on-fleek@1x.png"
                    />
                    <div class="surnameM raleway-bold-eerie-black-15pxM">
                      Barber
                    </div>
                    <img
                      alt=""
                      class="ligne-3M"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                    />
                  </div>
                </a>
                <a
                  href="/categories/onglerie"
                  style={{ textDecoration: "none" }}
                >
                  <div class="overlap-group-1M">
                    <img
                      alt=""
                      class="x-on-fleekM"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/onglerie-on-fleek@1x.png"
                    />
                    <div class="onglerieM raleway-bold-eerie-black-15pxM">
                      Onglerie
                    </div>
                    <img
                      alt=""
                      class="ligne-3M"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                    />
                  </div>
                </a>
              </div>
              <div
                class="overlap-group-containerM"
                style={{
                  width: size.width === 428 && 381,
                }}
              >
                <a href="/categories/beaute" style={{ textDecoration: "none" }}>
                  <div class="overlap-groupM">
                    <img
                      alt=""
                      class="x-on-fleekM"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/beaute-on-fleek@1x.png"
                    />
                    <div class="beautM raleway-bold-eerie-black-15pxM">
                      Beauté
                    </div>
                    <img
                      alt=""
                      class="ligne-3-1M"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                    />
                  </div>
                </a>
                <a
                  href="/categories/bien-etre"
                  style={{ textDecoration: "none" }}
                >
                  <div class="overlap-group-1M">
                    <img
                      alt=""
                      class="x-on-fleekM"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/bien-etre-on-fleek-5@1x.png"
                    />
                    <div class="bien-treM raleway-bold-eerie-black-15pxM">
                      Bien-être
                    </div>
                    <img
                      alt=""
                      class="ligne-3-1M"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                    />
                  </div>
                </a>
              </div>
            </>
          ) : (
            <>
              <a href="/categories/coiffure" style={{ textDecoration: "none" }}>
                <div
                  class="overlap-group-2M"
                  style={{
                    width: size.width > 390 ? 378 : size.width === 390 && 341,
                    left: size.width == 375 && 10,
                    left: size.width <= 360 && 18,
                  }}
                >
                  <div class="coiffeurM raleway-bold-eerie-black-15pxM">
                    Coiffure
                  </div>
                  <img
                    style={{
                      top: 190,
                      left: 10,
                    }}
                    alt=""
                    class="ligne-3M"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                  />
                  <img
                    alt=""
                    class="coiffure-mobile-on-fleekM"
                    src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/coiffure-mobile-on-fleek@1x.png"
                  />
                </div>
              </a>

              <div
                class="overlap-group-containerM"
                style={{
                  width: size.width === 428 && 381,
                  left: size.width <= 360 && 18,
                }}
              >
                <a href="/categories/barber" style={{ textDecoration: "none" }}>
                  <div class="overlap-groupM">
                    <img
                      alt=""
                      class="x-on-fleekM"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/barber-on-fleek@1x.png"
                    />
                    <div class="surnameM raleway-bold-eerie-black-15pxM">
                      Barber
                    </div>
                    <img
                      alt=""
                      class="ligne-3M"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                    />
                  </div>
                </a>
                <a
                  href="/categories/onglerie"
                  style={{ textDecoration: "none" }}
                >
                  <div class="overlap-group-1M">
                    <img
                      alt=""
                      class="x-on-fleekM"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/onglerie-on-fleek@1x.png"
                    />
                    <div class="onglerieM raleway-bold-eerie-black-15pxM">
                      Onglerie
                    </div>
                    <img
                      alt=""
                      class="ligne-3M"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                    />
                  </div>
                </a>
              </div>
              <div
                class="overlap-group-containerM"
                style={{
                  width: size.width === 428 && 381,
                  left: size.width <= 360 && 18,
                }}
              >
                <a href="/categories/beaute" style={{ textDecoration: "none" }}>
                  <div class="overlap-groupM">
                    <img
                      alt=""
                      class="x-on-fleekM"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/beaute-on-fleek@1x.png"
                    />
                    <div class="beautM raleway-bold-eerie-black-15pxM">
                      Beauté
                    </div>
                    <img
                      alt=""
                      class="ligne-3-1M"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                    />
                  </div>
                </a>
                <a
                  href="/categories/bien-etre"
                  style={{ textDecoration: "none" }}
                >
                  <div class="overlap-group-1M">
                    <img
                      alt=""
                      class="x-on-fleekM"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/bien-etre-on-fleek-5@1x.png"
                    />
                    <div class="bien-treM raleway-bold-eerie-black-15pxM">
                      Bien-être
                    </div>
                    <img
                      alt=""
                      class="ligne-3-1M"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62346c85f5e4e17d76f280fe/img/ligne-3-5@1x.png"
                    />
                  </div>
                </a>
              </div>
            </>
          )}
        </div>
      ) : (
        <div class="catgoriesW">
          <div class="h2-webW">
            <h1 class="dcouvrez-nos-professionnelsW raleway-extra-bold-eerie-black-45pxW">
              Découvrez nos professionnels
            </h1>
          </div>
          <Box
            style={{
              width: "100%",
              backgroundColor: "#fff",
              paddingLeft: "0%",
              paddingRight: "0%",
              paddingTop: 49.6,
              paddingBottom: 0,
            }}
          >
            <Container
              style={{
                marginLeft: size.width == 810 ? 0 : -17,
                margin: size.width >= 1900 && 0,
                // width: 1025,
                maxWidth: size.width > 1400 && size.width,
              }}
            >
              <Row className="customPro">
                <Column className="colCustomPro">
                  <a
                    href="/categories/coiffure"
                    style={{ textDecoration: "none" }}
                  >
                    <div class="overlap-groupW">
                      <img
                        alt=""
                        class="bien-etre-on-fleekW"
                        src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/bien-etre-on-fleek-1@1x.png"
                      />
                      <div class="groupe-7-2W">
                        <div class="h3-webW">
                          <div class="surnameW raleway-bold-eerie-black-18pxW">
                            Coiffure
                          </div>
                        </div>
                        <img
                          alt=""
                          class="ligne-3W"
                          src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/ligne-3-5@1x.png"
                        />
                      </div>
                    </div>
                  </a>
                </Column>
                <Column className="colCustomPro">
                  <a
                    href="/categories/barber"
                    style={{ textDecoration: "none" }}
                  >
                    <div class="overlap-groupW">
                      <img
                        alt=""
                        class="bien-etre-on-fleekW"
                        src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/bien-etre-on-fleek-2@1x.png"
                      />
                      <div class="groupe-7-2W">
                        <div class="h3-web-1W">
                          <div class="surnameW raleway-bold-eerie-black-18pxW">
                            Barber
                          </div>
                        </div>
                        <img
                          alt=""
                          class="ligne-3W"
                          src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/ligne-3-5@1x.png"
                        />
                      </div>
                    </div>
                  </a>
                </Column>
                <Column className="colCustomPro">
                  <a
                    href="/categories/onglerie"
                    style={{ textDecoration: "none" }}
                  >
                    <div class="overlap-groupW">
                      <img
                        alt=""
                        class="bien-etre-on-fleekW"
                        src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/bien-etre-on-fleek-3@1x.png"
                      />
                      <div class="groupe-7-2W">
                        <div class="h3-web-2W">
                          <div class="onglerieW raleway-bold-eerie-black-18pxW">
                            Onglerie
                          </div>
                        </div>
                        <img
                          alt=""
                          class="ligne-3W"
                          src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/ligne-3-5@1x.png"
                        />
                      </div>
                    </div>
                  </a>
                </Column>
                <Column className="colCustomPro">
                  <a
                    href="/categories/beaute"
                    style={{ textDecoration: "none" }}
                  >
                    <div class="overlap-groupW">
                      <img
                        alt=""
                        class="bien-etre-on-fleekW"
                        src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/bien-etre-on-fleek-4@1x.png"
                      />
                      <div class="groupe-7-2W">
                        <div class="h3-web-3W">
                          <div class="beautW raleway-bold-eerie-black-18pxW">
                            Beauté
                          </div>
                        </div>
                        <img
                          alt=""
                          class="ligne-3W"
                          src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/ligne-3-5@1x.png"
                        />
                      </div>
                    </div>
                  </a>
                </Column>
                <Column className="colCustomPro">
                  <a
                    href="/categories/bien-etre"
                    style={{ textDecoration: "none" }}
                  >
                    <div class="overlap-groupW">
                      <img
                        alt=""
                        class="bien-etre-on-fleekW"
                        src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/bien-etre-on-fleek-5@1x.png"
                      />
                      <div class="groupe-7-2W">
                        <div class="h3-web-4W">
                          <div class="bien-treW raleway-bold-eerie-black-18pxW">
                            Bien-être
                          </div>
                        </div>
                        <img
                          alt=""
                          class="ligne-3W"
                          src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6234af68a40ce154909bb2e5/img/ligne-3-5@1x.png"
                        />
                      </div>
                    </div>
                  </a>
                </Column>
              </Row>
            </Container>
          </Box>
        </div>
      )}
    </>
  );
};

const ContactComponent = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {size.width > 816 ? (
        <Box
          className="boxBeaute"
          style={{
            backgroundColor: "#fff",
            paddingLeft:
              size.width > 816 ? (size.width === 800 ? "5%" : "12%") : "0",
            paddingRight:
              size.width > 816 ? (size.width === 800 ? "5%" : "12%") : "0%",
            paddingTop: size.width > 816 ? "5vh" : 20,
            paddingBottom: size.width > 816 ? "5vh" : 20,
          }}
        >
          <Container
            style={{
              flexDirection: "row",
            }}
          >
            <svg
              width={size.width > 816 ? size.width + 240 : 816}
              height={size.width > 816 ? 400 + 110 : size.height / 6}
              viewBox="0 0 1160 400"
            >
              <defs>
                <style>
                  {
                    ".a{fill:#1d1d1b;}.b{stroke:#707070;fill:url(#a);}.c,.d,.f{fill:#fff;}.c{font-size:40px;font-family:Raleway-ExtraBold, Raleway;font-weight:800;}.d{font-size:16px;font-family:Roboto-Regular, Roboto;}.e,.h{fill:none;}.e{stroke:#fff;stroke-width:2px;}.f{font-size:18px;font-family:Raleway-Bold, Raleway;font-weight:700;}.g{stroke:none;}"
                  }
                </style>
                <pattern
                  id="a"
                  width={1}
                  height={1}
                  viewBox="81 46.286 376.599 307.428"
                >
                  <image
                    preserveAspectRatio="xMidYMid slice"
                    width={538.6}
                    height={400}
                    xlinkHref="contact-1.png"
                  />
                </pattern>
              </defs>
              <g transform="translate(-140 -2132)">
                <rect
                  className="a"
                  width={1160}
                  height={400}
                  rx={30}
                  transform="translate(140 2132)"
                />
                <g className="b" transform="translate(140 2132)">
                  <path
                    className="g"
                    d="M30,0H490a0,0,0,0,1,0,0V400a0,0,0,0,1,0,0H30A30,30,0,0,1,0,370V30A30,30,0,0,1,30,0Z"
                  />
                  <path
                    className="h"
                    d="M30,.5H489.5a0,0,0,0,1,0,0v399a0,0,0,0,1,0,0H30A29.5,29.5,0,0,1,.5,370V30A29.5,29.5,0,0,1,30,.5Z"
                  />
                </g>
                <text className="c" transform="translate(713 2213)">
                  <tspan x={0} y={0}>
                    {"Vous \xEAtes un professionnel"}
                  </tspan>
                  <tspan x={0} y={50}>
                    {"de la beaut\xE9 ?"}
                  </tspan>
                </text>
                <text className="d" transform="translate(713 2309)">
                  <tspan x={0} y={0}>
                    {
                      "Coiffure, beaut\xE9, bien \xEAtre, onglerie\u2026 Vous exercez un de ces m\xE9tiers ?"
                    }
                  </tspan>
                  <tspan x={0} y={21}>
                    {
                      "N\u2019attendez plus, adoptez le r\xE9flexe On Fleek, gagnez du temps sur vos prises"
                    }
                  </tspan>
                  <tspan x={0} y={42}>
                    {
                      "de rendez-vous et limiter les annulations de derni\xE8res minutes."
                    }
                  </tspan>
                </text>
                <g transform="translate(713 2375)">
                  <g className="e">
                    <rect className="g" width={167} height={42} rx={10} />
                    <rect
                      className="h"
                      x={1}
                      y={1}
                      width={165}
                      height={40}
                      rx={9}
                    />
                  </g>
                  <a href="/pro">
                    <text className="f" transform="translate(84 26)">
                      <tspan x={-66.681} y={0}>
                        {"Rejoignez-nous"}
                      </tspan>
                    </text>
                  </a>
                </g>
              </g>
            </svg>
          </Container>
        </Box>
      ) : (
        <div
          style={{
            backgroundColor: "#1D1D1B",
            marginLeft: size.width == 810 ? "-2rem" : "-0.7rem",
          }}
        >
          <svg
            width={
              size.width > 428
                ? "calc(" + size.width + (size.width == 810 ? " + 200px)" : ")")
                : size.width
            }
            height={size.width + size.width == 810 && 80}
            viewBox="0 0 428 455"
          >
            <defs>
              <style>
                {
                  ".a{fill:#1d1d1b;}.b{fill:url(#a);}.c,.d,.f{fill:#fff;}.c{font-size:20px;font-family:Raleway-ExtraBold, Raleway;font-weight:800;}.d,.f{font-size:15px;}.d{font-family:Roboto-Regular, Roboto;}.e,.h{fill:none;}.e{stroke:#fff;}.f{font-family:Raleway-Bold, Raleway;font-weight:700;}.g{stroke:none;}"
                }
              </style>
              <pattern
                id="a"
                preserveAspectRatio="xMidYMid slice"
                width="100%"
                height="100%"
                viewBox="0 0 600 343"
              >
                <image
                  width={600}
                  height={350}
                  xlinkHref="Pro-Mobile-On-Fleek.png"
                />
              </pattern>
            </defs>
            <g transform="translate(41.52 24)">
              <rect
                className="a"
                width={428}
                height={455}
                transform="translate(-41.52 -24)"
              />
              <rect
                className="b"
                width={373}
                height={200}
                transform="translate(-4.52 11)"
              />
              <text className="c" transform="translate(-4.52 250)">
                <tspan x={0} y={0}>
                  {"Vous \xEAtes un professionnel de la"}
                </tspan>
                <tspan x={0} y={20}>
                  {"beaut\xE9 ?"}
                </tspan>
              </text>
              <text className="d" transform="translate(-4.52 285)">
                <tspan x={0} y={16}>
                  {
                    "Coiffure, beaut\xE9, bien \xEAtre, onglerie\u2026 Vous exercez un "
                  }
                </tspan>
                <tspan x={0} y={36}>
                  {
                    "de ces m\xE9tiers ? N\u2019attendez plus, adoptez le r\xE9flexe "
                  }
                </tspan>
                <tspan x={0} y={56}>
                  {"On Fleek et gagnez du temps sur vos prises de "}
                </tspan>
                <tspan x={0} y={76}>
                  {"rendez-vous."}
                </tspan>
              </text>
              <g transform="translate(-4.52 378)">
                <g className="e">
                  <rect className="g" width={130} height={35} rx={5} />
                  <rect
                    className="h"
                    x={0.5}
                    y={0.5}
                    width={129}
                    height={34}
                    rx={4.5}
                  />
                </g>
                <a href="/pro">
                  <text className="f" transform="translate(65 22)">
                    <tspan x={-55.568} y={0}>
                      {"Rejoignez-nous"}
                    </tspan>
                  </text>
                </a>
              </g>
            </g>
          </svg>
        </div>
      )}
    </>
  );
};

const Question = ({ question = "", response = "", info = "" }) => {
  const [open, setOpen] = useState(false);

  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <button
      className="buttonfaq"
      onClick={() => {
        setOpen(!open);
      }}
      style={{
        border: "2px solid black",
        borderRadius: 10,
        backgroundColor: "#fff",
        marginTop: size.width > 700 ? 20 : 15,
        marginBottom: size.width > 700 ? 20 : 15,
        width:
          size.width > 800
            ? null
            : size.width <= 414
            ? size.width - 56.7
            : size.width >= 414
            ? "75%"
            : "100%",
        maxWidth: size.width - 56.7,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          paddingTop: size.width > 700 ? 28 : 13,
          paddingBottom: size.width > 700 ? 28 : 13,
          paddingLeft: size.width > 700 ? 20 : 13,
          paddingRight: size.width > 700 ? 20 : 13,
        }}
      >
        <p
          className="font-face-rb"
          style={{
            color: "black",
            fontSize: size.width > 700 ? 20 : 15,
            textAlign: "left",
          }}
        >
          {question}
        </p>
        <img
          src={process.env.PUBLIC_URL + "/down.faq.png"}
          alt="down.faq"
          style={{
            transform: !open ? "rotate(0deg)" : "rotate(180deg)",
            height: size.width > 700 ? 16 : 12,
            width: size.width > 700 ? 24.66 : 20,
            alignSelf: "center",
          }}
        />
      </div>
      {open && (
        <>
          <div style={{ height: 2, width: "100%", backgroundColor: "black" }} />
          <p
            className="font-face-rm"
            style={{
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 23,
              paddingBottom: 23,
              color: "#707070",
              fontSize: size.width > 700 ? 18 : 14,
              fontWeight: size.width > 700 ? 25 : 20,
              textAlign: "start",
              width: "90%",
            }}
          >
            {response}

            {info && (
              <>
                <br />
                <br />
                <i
                  style={{
                    fontStyle: "italic",
                  }}
                >
                  {info}
                </i>
              </>
            )}
          </p>
        </>
      )}
    </button>
  );
};

const FAQ = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Box
      style={{
        width: "100%",
        paddingTop: size.width > 700 ? 85 : 35,
        paddingBottom: size.width > 700 ? 85 : 35,
        paddingLeft: size.width > 700 ? "2rem" : "9%",
        paddingRight: size.width > 700 ? "2rem" : "9%",
        backgroundColor: "#F1F1F1",
      }}
    >
      <Container
        className="boxFAQ"
        style={{
          maxWidth: 1920,
          width: size.width > 1280 ? "79%" : size.width > 810 ? "100%" : "99%",
          margin: "auto",
        }}
      >
        <RowTow className="faqRow">
          <ColumnTow>
            <p
              className="font-face-rb"
              style={{
                color: "black",
                textAlign: "left",
                fontSize: size.width > 700 ? 35 : 20,
                paddingTop: size.width > 700 ? 20 : 0,
                paddingBottom: size.width > 700 ? 25 : 10,
              }}
            >
              F.A.Q
            </p>
            <p
              className="font-face-rsb"
              style={{
                color: "#BFBFBF",
                textAlign: "left",
                fontSize: window.innerWidth > 700 ? 30 : 15,
              }}
            >
              Vous vous posez des questions?
              <br />
              Nous avons les réponses.
            </p>
          </ColumnTow>
          <ColumnTow>
            <Question
              question="Comment ça marche?"
              response={`Dans le moteur de recherche 'On Fleek' vous pouvez taper le nom du salon ou la prestation que vous désirez effectuer, la ville ou l’adresse du salon ou institut, la date et l’heure. Vous aurez alors une sélection de salon ou institut qui correspondent à vos critères.

Choisissez le salon que vous désirez, puis la prestation souhaitée. Si vous n’êtes pas connecté, cliquez sur l’icône 'utilisateur' qui se trouve dans la barre de navigation et suivez les instructions à l’écran.

Une fois toutes ces étapes validées, vous recevrez un mail de confirmation de RDV. Un SMS de rappel vous sera également envoyé 4h avant votre rendez-vous.
`}
            />
            <Question
              question="Est-ce que je peux régler ma prestation en ligne ?"
              response="
                    Non, votre prestation sera à régler sur place avec le professionnel directement. Cependant, certains prestataires exigent un acompte pour confirmer le rendez-vous, dans ce cas il vous faudra entrer votre carte de paiement (Visa, Mastercard, American Express) afin de régler l’acompte demandé, le reste de la prestation sera à régler directement sur place. Des frais de services de 1€ seront appliqués à chaque paiement d’acompte."
            />
            <Question
              question="Est-ce que je peux décaler ou annuler un RDV ?"
              response="
                    Oui, une fois votre rendez-vous enregistré, vous pouvez si vous le souhaitez, le modifier ou l’annuler. Pour modifier ou annuler un rendez-vous il faut vous rendre sur votre compte en cliquant  sur l’icône 'utilisateur' qui se trouve dans la barre de navigation, si vous n’êtes pas connecté entrez votre identifiant et votre mot de passe (si vous avez oublié votre mot de passe, cliquez sur mot de passe oublié, un mail vous sera alors envoyé afin de le modifier.) Si vous n’avez pas encore de compte, cliquez sur s’inscrire et suivez les instructions à l’écran."
              info="Attention conformément à l’article L214-1 du code de la consommation, les arrhes ne peuvent être remboursées, par conséquent si vous avez déjà payé un acompte il sera perdu."
            />

            <Question
              question="Je suis un professionnel, comment ajouter mon salon ou mon institut sur On Fleek ?"
              response="
                    Pour ajouter votre salon ou institut c’est très simple, cliquez sur le bouton espace pro dans la barre de navigation, remplissez le formulaire, nous vous recontacterons dans les plus bref délais."
            />

            {/* <Question
              question="La cinquième question"
              response="
                    Les questions F.A.Q se présentent sour forme de menu
                    déroulant, elles répondent aux questions principales
                    des particuliers mais aussi des professionnels"
            /> */}
          </ColumnTow>
        </RowTow>
      </Container>
    </Box>
  );
};

const Home = () => {
  return (
    <div>
      <Hero />
      {/* <div class="container mx-auto">
        <h1 className="text-blue-400 font-extrabold">Hello World!</h1>
      </div> */}
      <DiscoverPro />
      <AproposComponent />
      <ContactComponent />
      <FAQ />
      <Covid />
    </div>
  );
};

export default Home;
